module.exports = __webpack_public_path__ + "media/images/h1-34670a0d160e8523f748d1aa0717cd15.svg";